import React from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import Home from './components/Home';
import AboutUs from "./components/AboutUs";
import Service from "./components/Service";
import Product from "./components/Product";
import ContactUs from "./components/ContactUs";
import { HelmetProvider } from "react-helmet-async";

function App() {
  const isApiGateway =
  window.location.hostname.includes("execute-api");

const basename = isApiGateway ? "/prod" : "";

  return (
   <HelmetProvider>
    <BrowserRouter basename={basename}>
      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<AboutUs />} />
        <Route path="/service" element={<Service />} />
        <Route path="/product" element={<Product />} />
        <Route path="/contact" element={<ContactUs />} />
      </Routes>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
